import React from "react";
import ContentPage from "../components/content-page";
import SEO from "../components/seo";
var AuthorAgreementPage = function AuthorAgreementPage(_ref) {
    var data = _ref.data;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SEO, {
        title: data.datoCmsAuthorAgreement.title
    }), /*#__PURE__*/ React.createElement(ContentPage, {
        title: data.datoCmsAuthorAgreement.title,
        content: data.datoCmsAuthorAgreement.content
    }));
};
var query = "472910624";
export default AuthorAgreementPage;
